import { ReactNode } from 'react'

import { Icon, Message, NoContentContainer } from './styles'

interface INoCommentsProps {
  backgroundColor: string
  children: ReactNode
}

export function NoComments({ backgroundColor, children }: INoCommentsProps) {
  return (
    <NoContentContainer backgroundColor={backgroundColor}>
      <Icon name="insert-comment" />
      <Message>{children}</Message>
    </NoContentContainer>
  )
}
